import { useController } from "react-hook-form";

import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import { TextareaField } from "./TextareaField";

export type FormTextareaProps = {
    defaultValue?: string;
    endElement?: React.ReactNode;
    helperText?: string;
    label: string;
    name: string;
    placeholder?: string;
};

export function FormTextarea({
    defaultValue = "",
    endElement,
    helperText,
    label,
    name,
    placeholder,
}: FormTextareaProps) {
    const { field, fieldState } = useController({
        name,
        defaultValue,
    });

    return (
        <FieldWrapper name={field.name}>
            <TextareaField
                endElement={endElement}
                helperText={helperText}
                inputRef={field.ref}
                isError={!!fieldState.error}
                label={label}
                name={field.name}
                onChange={field.onChange}
                placeholder={placeholder}
                value={field.value}
            />
        </FieldWrapper>
    );
}
